"use strict";

var $ = require("jquery");
var MAIN_TEMPLATE = require("../html/ConsentForm.html");
var uuid = require("./uuidMIT");



require("../style/general.scss");
require("../style/uim-widget.scss");
var common = require("./common");
var templatesText = require("../json/TemplatesText.json");

var OPTIONAL_FIELDS = [{
    selector: ".ie789-only",
    configKey: "showLabels"
}];

function UimConsentFormWidget(params) {
    common.validateParams(params);
    this.successCallback = params.configuration.success || window.morningstar.uim.success;
    this.errorCallback = params.configuration.error || window.morningstar.uim.error;
    this.apigeeKey = params.configuration.apigeeKey;
    this.environment = params.configuration.environment;
    this.element = params.element;
    this.locale = common.getUrlParameter("culture");
    this.clientId = common.getUrlParameter("client_id");
    this.redirectURI = common.getUrlParameter("redirect_uri");
    this.oauthScope = common.getUrlParameter("scope");
    this.responseType = common.getUrlParameter("response_type");
    this.realm = common.getUrlParameter("realm") === undefined ? "msusers" : common.getUrlParameter("realm");
    this.apiUrl = common.API_ENVIRONMENTS[this.environment] + '/sso/oauth2/'+this.realm+ '/authorize';
    this.oauthQueryString = 'client_id='+this.clientId+'&redirect_uri='+this.redirectURI+'&scope='+this.oauthScope+'&response_type='+this.responseType;
}

function filterScope(scope) {
    return (scope !== "msguid") && (scope !== "msrole");
}

UimConsentFormWidget.prototype.init = function () {
    var self = this,
        languagesSupport = ["it", "es", "nl", "fr", "de", "se", "nb", "fi", "da", "th", "en","it-it", "es-cl","es-mx", "nl-be","nl-nl", "fr-fr","fr-ch", "de-de","de-at","de-ch", "se-se", "nb-no", "fi-fi", "da-dk", "th-th", "en-us","en-gb","en-in","en-no","en-ch","en-ca"],
        language = common.getUserPreferredLocale(this.locale, languagesSupport),
        handleBarTemplates = window.morningstar.uim.templates,
        // Select the widget data using language locale
        widgetText = templatesText[language];
        var consentFormParent = this.element;
        var requestId = uuid();

        $.ajax({
            method: "GET",
            url: this.apiUrl + "?" + this.oauthQueryString,
            xhrFields: { withCredentials:true },
            headers : {
                ApiKey : this.apigeeKey,
                "X-API-RequestId": requestId
            },
            dataType: 'json'
        }).success(function(data, status, jqXHR) {


            if(jqXHR.status === 201) {
                window.location.replace(jqXHR.responseJSON.location);
            }else {
                consentFormParent.append(MAIN_TEMPLATE);
                $("input[name=decision_btn]").on("click", function (e) {
                    e.preventDefault();
                    var decisionVal = $(this).attr("value") === "Cancel" ? "Deny" : "Allow";
                    $("#decision").val(decisionVal);
                    self.consentDecision(requestId);
                });

                var scopeArray = data.oauth2Data.scope.split(" ");
                scopeArray = scopeArray.filter(filterScope);

                if ((scopeArray[0] !== undefined) && (!scopeArray[0].startsWith("portfolios."))){
                    var generic_au_msg="You are requesting Morningstar make available certain information and " +
                        "data from your Morningstar account to <span class=\"oauth-client-name\"></span>.\n" +
                        "\t\t\t\tMorningstar will provide data including, but not limited to, the following:<br>";
                    var au_msg_scope="";
                    for (var j = 0; j < data.oauth2Data.displayScopes.length; j++) {
                        if ((data.oauth2Data.displayScopes[j].name !== "msguid") && (data.oauth2Data.displayScopes[j].name !== "msrole")) {
                            au_msg_scope += ("<li>"+data.oauth2Data.displayScopes[j].name+"</li>");
                        }
                    }
                    document.getElementById("consent_text").innerHTML = generic_au_msg + au_msg_scope;
                }

                $("#consent-form").attr("action", this.apiUrl);
                $(".oauth-client-name").html(data.oauth2Data.displayName);
                $("#csrf").val(data.oauth2Data.csrf);
                $("#client_id").val(data.oauth2Data.clientId);
                $("#scope").val(data.oauth2Data.scope);
                $("#redirect_uri").val(data.oauth2Data.redirectUri);
                $("#response_type").val(data.oauth2Data.responseType);
                this.oauth2Data = data.oauth2Data;
            }
        }).error(function (data) {
            if(data.status === 401) {
                window.location.replace(data.responseJSON.location);
            }else{
                window.location.replace("./AccessDenied.html");
            }
        });
};

UimConsentFormWidget.prototype.consentDecision = function(requestId){
    $.ajax({
        method: "POST",
        url: this.apiUrl,
        data: {
            csrf : $("#csrf").val(),
            client_id: $("#client_id").val(),
            scope : $("#scope").val(),
            redirect_uri : $("#redirect_uri").val(),
            response_type: $("#response_type").val(),
            decision: $("#decision").val()
        },
        xhrFields: { withCredentials:true },
        headers : {
            ApiKey : this.apigeeKey,
            "X-API-RequestId": requestId
        }
    }).success(function(data, status, xhr) {
        window.location.replace(data);
    }).error(function(data) {
        window.location.replace(data.responseText);
    });
};

module.exports = {
    createComponent: function (params) {
        var uimWidget = new UimConsentFormWidget(params);
        uimWidget.init();

        return {
            setProperty: function () {},
            destroy: function () {
                params.element.children().remove();
            }
        };
    }
};



//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/js/consent-form.js
// module id = 45
// module chunks = 0